module.exports = __webpack_public_path__ + "img/sup_cardsetting_ewalleti2.7c3a9c57.jpg";